import TableStorage from './Table'

export default function Information() {
    return (
        <>
            <TableStorage />
        </>
    )
}
